import { Lens } from '@dhmk/zustand-lens';

type AchievementsNotificationModalsProperties = {
  referralPrevRank: string;
  referralPrevPoints: number;
  referralPrevAssetsRank: string;
  referralPrevAssetsPoints: number;
};
type AchievementsNotificationModalsActions = {
  setData: (_state: Partial<AchievementsNotificationModalsProperties>) => void;
};
export type AchievementsNotificationModalsSlice = AchievementsNotificationModalsProperties &
  AchievementsNotificationModalsActions;

const initialState = {
  referralPrevRank: 'None',
  referralPrevPoints: 0,
  referralPrevAssetsRank: 'None',
  referralPrevAssetsPoints: 0,
};

export const createAchievementsNotificationModalsSlice: Lens<
  AchievementsNotificationModalsSlice
> = (set) => ({
  ...initialState,
  setData: (data) =>
    set((state) => {
      return { ...state, ...data };
    }),
});
